import React from 'react';
import MicNoneIcon from '@mui/icons-material/MicNone';
import { AudioWave } from './AudioWave';
import { Box, Grid, useTheme, DialogContent, DialogActions } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { translate } from 'translations/translator';
import CommonTranslationVariant from 'translations/variants/common';
import { HwtButton } from 'components/@common/Buttons/HwtButton';

type Props = {
  onStart: () => void;
  teacherInstructions: boolean;
};
const t = (key: CommonTranslationVariant) => translate('common', key);

export const StartComponent: React.FC<Props> = ({ onStart, teacherInstructions }: Props) => {
  const theme = useTheme();
  const classes = useStyles(theme)();

  const startRecording = teacherInstructions
    ? t(CommonTranslationVariant.startRecordingInstructions)
    : '';

  return (
    <Box>
      <DialogContent className={classes.content}>
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <MicNoneIcon className={classes.icon} />
          <p className={classes.paragraph}>{startRecording}</p>
          <Box component={'div'} className={classes.waveBox}>
            <AudioWave color={'primary.dark'} animation={false} />
          </Box>
        </Grid>
      </DialogContent>
      <DialogActions>
        <HwtButton
          onClick={onStart}
          variant="contained"
          color="inherit"
          startIcon={<MicNoneIcon />}
          style={{
            width: '181px',
            margin: '16px'
          }}
        >
          {t(CommonTranslationVariant.startRecording)}
        </HwtButton>
      </DialogActions>
    </Box>
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    waveBox: () => ({
      backgroundColor: theme.palette.kinder.lighter,
      borderRadius: '4px',
      width: '732px',
      height: '120px',
      marginBottom: '10px'
    }),
    content: {
      width: '800px',
      height: '281px'
    },
    icon: {
      fontSize: '88px !important'
    },
    paragraph: () => ({
      color: theme.palette.black.light,
      fontSize: '18px',
      fontWeight: 300,
      fontStyle: 'normal',
      marginBottom: '10px'
    })
  }));
